import { getThdProductDetails } from '../../api/thdApi';

// you do you, bro
// console.log wrapper is needed because (you guessed it) IE
const getThdProductDetailsOrNotItsCool = (skus, storeId, config) =>
  // eslint-disable-next-line no-console
  getThdProductDetails(skus, storeId, config).catch((err) => console.log(err));

export default getThdProductDetailsOrNotItsCool;
